import { Fragment } from 'react';

import { Grid, GridItem, Text } from '@farmersdog/corgi-x';
import { Check } from '@farmersdog/corgi-x/icons';

import styles from './CheckmarkList.module.css';

interface CheckmarkListProps {
  listItems: string[];
}

export function CheckmarkList(props: CheckmarkListProps) {
  return (
    <Grid gap="sm" alignItems="baseline">
      {props.listItems.map(item => (
        <Fragment key={item}>
          <GridItem xs={1}>
            <Check
              className={styles.checkmark}
              height={16}
              width={14}
              baseColor="Kale2"
            />
          </GridItem>
          <GridItem xs={11}>
            <Text variant="heading-16">{item}</Text>
          </GridItem>
        </Fragment>
      ))}
    </Grid>
  );
}
